export default (templateKeys = [], thisTemplate) => {
  let surveyResultDataFrame = {
    key: 'surveys',
    name: 'Survey Results',
    text: '{{surveys}}',
    attributeFieldType: 'dataFrame',
    subAttribute: {
      size: 2,
      attributes: [
        {
          key: 'surveyQuestion',
          name: 'Survey Question',
          dataType: 'String',
          text: '{{surveyQuestion}}'
        },
        {
          key: 'surveyResponse',
          name: 'Survey Response',
          dataType: 'String',
          text: '{{surveyResponse}}'
        }
      ]
    }
  };
  let allSurveyResultDataFrame = {
    key: 'allSurveyResults',
    name: 'All Survey Results',
    text: '{{allSurveyResults}}',
    attributeFieldType: 'dataFrame',
    subAttribute: {
      size: 2,
      attributes: [
        {
          key: 'surveyQuestion',
          name: 'Survey Question',
          dataType: 'String',
          text: '{{surveyQuestion}}'
        },
        {
          key: 'surveyResponse',
          name: 'Survey Response',
          dataType: 'String',
          text: '{{surveyResponse}}'
        }
      ]
    }
  };
  let keys = templateKeys.map(keys => {
    let schemaConditionAttributes = keys.schemaConditionAttributes?.filter(
      item =>
        item.attributeFieldType === 'dataFrame' && item?.subAttribute?.size
    );
    if (
      (keys.fieldFromSchema || keys.schemaType === "EVENT") &&
      thisTemplate?.surveyResponseTemplate === true
    ) {
      schemaConditionAttributes = [
        ...schemaConditionAttributes,
        surveyResultDataFrame,
        allSurveyResultDataFrame
      ];
    }
    return {
      ...keys,
      schemaConditionAttributes: schemaConditionAttributes
    };
  });
  return {
    hasList: keys.length > 0 ? true : false,
    namings: keys
      .filter(data => data.schemaConditionAttributes?.length > 0)
      .map(data => ({
        productName: data.productName,
        dataFrameNames: data.schemaConditionAttributes?.map(item => {
          return {
            key: item.key,
            label: item.name,
            value: item.name,
            hasNestedDataFrame: item.hasNestedDataFrame,
            metaAttribute: item.metaAttribute,
            description: item.description
          };
        })
      })),
    detailedList: keys
      .filter(data => data.schemaConditionAttributes?.length > 0)
      .map(data => ({
        productName: data.productName,
        fieldFromSchema: data.fieldFromSchema,
        schemaType: data.schemaType,
        dataFrames: data.schemaConditionAttributes?.map(item => {
          return {
            ...item,
            subAttribute: item?.subAttribute?.attributes
          };
        })
      }))
  };
};
